import { baseAPIRequest } from 'utilities/http';

function getLightingCollections (shortSku: string): Promise<LP.product.LightingCollectionResponse> {

	return baseAPIRequest({
		url: `/api/lightingCollection/${shortSku}`,
		params: {
			method: 'GET'
		},
		data: {},
		errorStatusHandlers: {},
		abortController: {},
		timer: 0
	});

}

export default getLightingCollections;
